import { combineReducers } from 'redux';
import { accountActionTypes as actionType } from 'src/constants/actionTypes';
import accountReducer from './accountReducer';
import auditReducer from './auditReducer';
import documentReducer from './documentReducer';
import repositoryReducer from './repositoryReducer';
import roleReducer from './roleReducer';
import policyReducer from './policyReducer';
import savedSearchReducer from './savedSearchReducer';
import uiReducer from './uiReducer';
import userReducer from './userReducer';
import siteReducer from './siteReducer';

const appReducer = combineReducers({
  account: accountReducer,
  audit: auditReducer,
  repository: repositoryReducer,
  document: documentReducer,
  role: roleReducer,
  policy: policyReducer,
  savedSearch: savedSearchReducer,
  user: userReducer,
  site: siteReducer,
  ui: uiReducer
});

const rootReducer = (state, action) => appReducer(
  action.type === actionType.LOGOUT
    ? undefined
    : state, action
);

export default rootReducer;
